import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function ScannedCertificateListHeaders() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        backgroundColor: 'primary.main',
        color: 'primary.contrastText',
        borderRadius: '4px 4px 0 0',
        px: 2,
        py: 1,
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          flex: '0 0 25%',
          fontWeight: 'bold',
        }}
      >
        {t('scanned_certificates.name')}
      </Typography>
      <Typography
        variant="subtitle2"
        sx={{
          flex: '0 0 12%',
          fontWeight: 'bold',
        }}
      >
        {t('scanned_certificates.type')}
      </Typography>
      <Typography
        variant="subtitle2"
        sx={{
          flex: '0 0 15%',
          fontWeight: 'bold',
        }}
      >
        {t('scanned_certificates.parser')}
      </Typography>
      <Typography
        variant="subtitle2"
        sx={{
          flex: '0 0 10%',
          fontWeight: 'bold',
        }}
      >
        {t('scanned_certificates.confidence')}
      </Typography>
      <Typography
        variant="subtitle2"
        sx={{
          flex: '0 0 18%',
          fontWeight: 'bold',
        }}
      >
        {t('scanned_certificates.processed_at')}
      </Typography>
      <Typography
        variant="subtitle2"
        sx={{
          flex: '0 0 15%',
          fontWeight: 'bold',
        }}
      >
        {t('scanned_certificates.status.status')}
      </Typography>
      <Typography
        variant="subtitle2"
        sx={{
          flex: '0 0 10%',
          fontWeight: 'bold',
        }}
      >
        {/* Actions column */}
      </Typography>
    </Box>
  );
}
